<template>
  <div class="ChangePassword">
    <div class="header syTitle acea-row row-center-wrapper">
        立数教育
    </div>
    <div class="syTitle2 acea-row row-center-wrapper">
        校园收费通取消手机绑定
    </div>
    <div class="list">
      <div class="item">
        <input type="number" placeholder="填写手机号码" v-model="phone" />
      </div>
      <div class="item acea-row row-between-wrapper">
        <input
          type="text"
          placeholder="填写验证码"
          class="codeIput"
          v-model="verifyCode"
        />
        <button
          class="code font-color-red"
          :disabled="disabled"
          :class="disabled === true ? 'on' : ''"
          @click="code"
        >
          {{ text }}
        </button>
      </div>
    </div>
    
    <div class="confirmBnt btnView" @click="confirm">取消绑定</div>

    <div class="acea-row row-center-wrapper text2">
        深圳市立数教育科技有限公司   技术支持
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import sendVerifyCode from "@mixins/SendVerifyCode";
import { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { cancelBindingPhone, sendSMS } from "@api/public";
import cookie from "@utils/store/cookie";

import { Dialog } from 'vant';
import { Toast } from 'vant';

export default {
  name: "BindingPhone",
  components: {
    [Dialog.name]:Dialog,
    [Toast.name]:Toast,
  },
  props: {},
  data: function() {
    return {
      verifyCode: "",
      phone: "" //手机号
    };
  },
  mixins: [sendVerifyCode],
  computed: mapGetters(["userInfo"]),
  mounted: function() {

  },
  methods: {
    isPoneAvailable(phone) {
            var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
            if (!myreg.test(phone)) {
                return false;
            } else {
                return true;
            }
        },
    async confirm() {
      let that = this;
      const { phone, verifyCode } = that;
      let openid = cookie.get("lishu-openid");

      if (that.isPoneAvailable(phone) == false) {
        Dialog.alert({
              message: "请输入正确手机号"
            });
        return;
      }

      console.log(openid);

      if (openid) {
          cancelBindingPhone(phone,openid,verifyCode)
                    .then((data, res) => {
                      console.log(data);

          if (data.code == 0) {
            Toast.success(
              {
                message: data.msg,
                onClose: () => {
                    window.location.href = "http://datum.lishuedu.com/firstPage";
                  }
              }
            )

          } else {
            Toast(data.msg);
          }
        });
      }

    },
    async code() {
      let that = this;
      const { phone } = that;
  
      // let ret = chs_phone(phone);
      // console.log(ret);

      

      if (that.isPoneAvailable(phone) == false) {
        Dialog.alert({
              message: "请输入正确手机号"
            });
        return;
      }

      sendSMS(phone)
        .then((data, res) => {
          if (data.code == 0) {

            that.sendCode();

            // Dialog.alert({
            //   message: "发送成功"
            // });
            Toast.success("发送成功");

            
          }else{
            Dialog.alert({
              message: data.msg
            });
          }
          
        })
        .catch(res => {
        });
    }
  }
};
</script>

<style scoped>
.index {
  background-color: #fff;
}
.btnView{
  background-color:#2EBCBF;
}
.syTitle {
  margin-top: 20px; 
  color: black;
  font-size: 20px;
  height: 50px;
}
.syTitle2 {
  color: black;
  font-size: 20px;
}

.text1 {
  margin-top: 20px;
  font-size: 12px;
}
.text2 {
  margin-top: 20%;
}
</style>
